var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.fieldAnalysis.code")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.fieldAnalysis.description1")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Description1))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.fieldAnalysis.status")) + ":")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.rowData.Status ? _vm.rowData.Status.Label : "")
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.fieldAnalysis.title"),
                  active: ""
                }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ValidityType,
                                "object",
                                "insert.fieldAnalysis.validityType"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.AnalysisType,
                                "object",
                                "insert.fieldAnalysis.analysisType"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.AnalysisPeriod,
                                "object",
                                "insert.fieldAnalysis.analysisPeriod"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ApproveState,
                                "object",
                                "insert.fieldAnalysis.approveState"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.AnalysisVisitCount,
                                "text",
                                "insert.fieldAnalysis.analysisVisitCount"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CustomerCriteria,
                                "object",
                                "insert.fieldAnalysis.customerCriteria"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.IsNecessary,
                                "check",
                                "insert.fieldAnalysis.isNecessary"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.UseOnce,
                                "check",
                                "insert.fieldAnalysis.useOnce"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.SortOrder,
                                "text",
                                "insert.fieldAnalysis.sortOrder"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.AnalysisTime,
                                "object",
                                "insert.fieldAnalysis.analysisTime"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.FollowingAnalysis,
                                "check",
                                "insert.fieldAnalysis.followingAnalysis"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.fieldAnalysis.question") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.fieldAnalysisQuestionItems,
                                "has-line-number": true
                              },
                              model: {
                                value: _vm.rowData.FieldAnalysisQuestions,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "FieldAnalysisQuestions",
                                    $$v
                                  )
                                },
                                expression: "rowData.FieldAnalysisQuestions"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.fieldAnalysis.branchs") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.fieldAnalysisBranchItems
                              },
                              model: {
                                value: _vm.rowData.FieldAnalysisBranchs,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "FieldAnalysisBranchs",
                                    $$v
                                  )
                                },
                                expression: "rowData.FieldAnalysisBranchs"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.fieldAnalysis.employeeType") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.fieldAnalysisEmployeeItems
                              },
                              model: {
                                value: _vm.rowData.FieldAnalysisEmployeeTypes,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "FieldAnalysisEmployeeTypes",
                                    $$v
                                  )
                                },
                                expression: "rowData.FieldAnalysisEmployeeTypes"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.rowData.ValidityType && _vm.rowData.ValidityType.Code === "SS"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      lazy: "",
                      title: _vm.$t("insert.fieldAnalysis.validDates")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.fieldAnalysisValidDateItems
                                  },
                                  model: {
                                    value: _vm.rowData.FieldAnalysisValidDates,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.rowData,
                                        "FieldAnalysisValidDates",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "rowData.FieldAnalysisValidDates"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CustomerCriteria &&
            _vm.rowData.CustomerCriteria.Code === "ML"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      lazy: "",
                      title: _vm.$t("insert.fieldAnalysis.customerList")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.fieldAnalysisCustomerItems
                                  },
                                  model: {
                                    value: _vm.customers,
                                    callback: function($$v) {
                                      _vm.customers = $$v
                                    },
                                    expression: "customers"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CustomerCriteria &&
            _vm.rowData.CustomerCriteria.Code === "MK"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      lazy: "",
                      title: _vm.$t("insert.fieldAnalysis.customerCriterias")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.itemAnalysisDetailItems
                                  },
                                  model: {
                                    value: _vm.customerCriterias,
                                    callback: function($$v) {
                                      _vm.customerCriterias = $$v
                                    },
                                    expression: "customerCriterias"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CustomerCriteria &&
            _vm.rowData.CustomerCriteria.Code === "MS"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      lazy: "",
                      title: _vm.$t("insert.terminalMessage.customerQuery")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.custSqlItems
                                  },
                                  model: {
                                    value: _vm.rowData.FieldAnalysisCustSqls,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.rowData,
                                        "FieldAnalysisCustSqls",
                                        $$v
                                      )
                                    },
                                    expression: "rowData.FieldAnalysisCustSqls"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a635349", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a635349","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FieldAnalysis/get.vue
// module id = null
// module chunks = 